import * as service from "../service";
import { store } from "../../store";

interface RegisterSocietyParams {
  society_name: string;
  university?: string;
  instagram_url?: string;
  society_icon?: string;
  hkid_url?: string;
  student_card_url?: string;
  chop_image_url?: string;
}

interface RegisterSocietyResult {
  society: {
    id: string;
    name: string;
    icon: string | null;
    university: string | null;
    /** Bare official handle; see `UserSociety.instagram_handle`. */
    instagram_handle: string | null;
    instagram_profile_url: string | null;
    instagram_url: string | null;
    chop_image_url: string | null;
  };
  membership: {
    id: string;
    verified: boolean;
  };
  already_verified: boolean;
}

/**
 * Register a new society / club for the current student.
 * Backend: POST /api/society/register
 */
export const RegisterSocietyAPI = async (
  params: RegisterSocietyParams,
): Promise<RegisterSocietyResult | { error: string } | null> => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("POST", "api/society/register", {
      user_id: student?.id,
      ...params,
    });
    if (resp?.status === 0 && resp?.result) {
      return resp.result as RegisterSocietyResult;
    }
    if (resp?.message) {
      return { error: resp.message };
    }
    return null;
  } catch (err) {
    console.error(`RegisterSocietyAPI ${err}`);
    return null;
  }
};
